import React from 'react';

export const ExistingPole = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="8" stroke="black" strokeWidth="2"/>
  </svg>
);

export const Pole = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="6" y1="6" x2="18" y2="18" stroke="black" strokeWidth="2"/>
    <line x1="18" y1="6" x2="6" y2="18" stroke="black" strokeWidth="2"/>
  </svg>
);

export const Transformer = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="9" y="6" width="6" height="12" stroke="black" strokeWidth="2"/>
  </svg>
);

export const Anchor = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <line x1="12" y1="4" x2="12" y2="20" stroke="black" strokeWidth="2"/>
    <line x1="4" y1="4" x2="20" y2="4" stroke="black" strokeWidth="2"/>
  </svg>
);

export const Switch = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 12C6 9.79086 7.79086 8 10 8C12.2091 8 14 9.79086 14 12C14 14.2091 12.2091 16 10 16C7.79086 16 6 14.2091 6 12Z" stroke="black" strokeWidth="2" fill="none"/>
    <path d="M10 12C10 9.79086 11.7909 8 14 8C16.2091 8 18 9.79086 18 12C18 14.2091 16.2091 16 14 16C11.7909 16 10 14.2091 10 12Z" stroke="black" strokeWidth="2" fill="none"/>
  </svg>
);

export const TerminatingCabinet = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="6" width="16" height="12" stroke="black" strokeWidth="2"/>
    <text x="12" y="14" textAnchor="middle" dominantBaseline="middle" fill="black" fontSize="8">TC</text>
  </svg>
);

export const SecondaryPedestal = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <polygon points="12,3 17,5 20,10 20,14 17,19 12,21 7,19 4,14 4,10 7,5" stroke="black" strokeWidth="2" fill="none"/>
    <text x="12" y="14" textAnchor="middle" dominantBaseline="middle" fill="black" fontSize="8" fontWeight="bold">SP</text>
  </svg>
);

export const Meter = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="8" stroke="black" strokeWidth="2" fill="none"/>
    <text x="12" y="14" textAnchor="middle" dominantBaseline="middle" fill="black" fontSize="10" fontWeight="bold">M</text>
  </svg>
);

// New icons for "Other" category
export const GeneralNote = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="4" width="16" height="16" rx="2" stroke="black" strokeWidth="2" fill="white"/>
    <line x1="8" y1="8" x2="16" y2="8" stroke="black" strokeWidth="1.5"/>
    <line x1="8" y1="11" x2="16" y2="11" stroke="black" strokeWidth="1.5"/>
    <line x1="8" y1="14" x2="12" y2="14" stroke="black" strokeWidth="1.5"/>
  </svg>
);

export const TreeTrimming = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Tree trunk - extends up to connect with circles */}
    <rect x="10" y="8" width="4" height="14" fill="none" stroke="black" strokeWidth="2"/>
    {/* Tree foliage - just 3 overlapping circles spread out more */}
    <circle cx="12" cy="4" r="4" fill="none" stroke="#0f5132" strokeWidth="2"/>
    <circle cx="6" cy="6" r="3" fill="none" stroke="#0f5132" strokeWidth="2"/>
    <circle cx="18" cy="6" r="3" fill="none" stroke="#0f5132" strokeWidth="2"/>
  </svg>
);

// Generic equipment icon if needed
export const Equipment = ({ type }) => {
  switch (type) {
    case 'transformer':
      return <Transformer />;
    case 'pole':
      return <Pole />;
    case 'underground':
      return <Underground />;
    default:
      return <Zap size={24} />;
  }
}; 